import React from "react";
import AsyncSelect from "react-select";
import PropTypes from "prop-types";

const EditFlightDiscountsPage = props => {
  const {
    selectedAirline,
    editDiscountCodeDetailId,
    allAirlines,
    handleInputChange,
    editDiscountCodeDetails,
    handleDiscountInputHandler,
    UpdateAirdiscount,
    onCancelDiscounthandler
  } = props;

  return (
    <div>
      <div className="inner-header">
        <div className="shape-header">
          <div className="left">R</div>
          <div className="right">
            <h6 className="heading">Edit Air Discounts</h6>
          </div>
          <div className="clearfix" />
        </div>
      </div>
      <div className="p-padding">
        <div className="form-holder">
          <div className="row">
            <div className="col-md-4">
              <div className="form-group custom labelup">
                <label>Vendor <span className="text-danger">*</span></label>
                <AsyncSelect
                  value={selectedAirline || editDiscountCodeDetailId}
                  options={allAirlines}
                  loadOptions={allAirlines}
                  onChange={handleInputChange}
                  placeholder="Search And Select"
                />
              </div>
              <div className="form-group custom">
                <input
                  className="form-control"
                  name="discountCode"
                  value={editDiscountCodeDetails.discountCode || ""}
                  placeholder="&nbsp;"
                  onChange={handleDiscountInputHandler}
                />
                <label>Discount Code <span className="text-danger">*</span></label>
              </div>
              <div>
                <div className="btn-group-margin">
                  <button className="btn" onClick={UpdateAirdiscount}>
                    Update
                  </button>
                  <button className="btn" onClick={onCancelDiscounthandler}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
EditFlightDiscountsPage.propTypes = {
  handleInputChange: PropTypes.func,
  handleDiscountInputHandler: PropTypes.func,
  UpdateAirdiscount: PropTypes.func,
  editDiscountCodeDetails: PropTypes.object,
  onCancelDiscounthandler: PropTypes.func,
  allAirlines: PropTypes.array
};
export default EditFlightDiscountsPage;
